import {useEffect} from 'react'
import {Hub} from 'yougile-model'
import {idTasksApi} from '@extensions/id-tasks/id-tasks-store'

export const useInitTaskIds = (board: Hub): void => {
  useEffect(() => {
    void idTasksApi.initBoard(board)
  }, [board?.id])
}
